module.exports = __webpack_public_path__ + "img/9788983946843.99dfccf8.jpg";